import Button, { ButtonProps } from "../button";
import { Modal, useModal } from "@/shared/modal";
import { useTranslations } from "use-intl";
import { SubmitWrapper } from "@/shared/form/button";
import { ReactNode } from "react";

export type ConfirmButtonProps = Omit<ButtonProps, "onClick" | "loading"> & {
  onClick?: () => Promise<void>;
  loading?: boolean;
  description?: ReactNode;
};

export function ConfirmButton({
  onClick,
  loading,
  description,
  ...props
}: ConfirmButtonProps) {
  const t = useTranslations("Common");
  const { open, openModal, close } = useModal();

  return (
    <>
      <Button onClick={open} {...props} />
      <Modal open={openModal} onCancel={close} title={t("Confirm action")}>
        <div>
          {description ?? t("Are you sure you want to perform this action?")}
        </div>
        <div className={"mt-10"}>
          <SubmitWrapper>
            <div className="space-x-2">
              <Button
                type={"primary"}
                danger
                onClick={close}
                disabled={loading}
              >
                {t("Cancel")}
              </Button>
              <Button
                type={"primary"}
                onClick={async () => {
                  await onClick?.();
                  close();
                }}
                loading={loading}
                disabled={!!loading}
              >
                {t("Agree")}
              </Button>
            </div>
          </SubmitWrapper>
        </div>
      </Modal>
    </>
  );
}
